import {Component, Inject, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {SubmissionSearchUserInfoObject} from './search-object';
import {SubmissionHistoryService} from '../../shared/services/submission-history.service';
import {Router} from '@angular/router';
import {AppComponent} from '../../app.component';

@Component({
  templateUrl: './kpi-root.component.html',
  styleUrls: ['./root.component.scss']
})
export class KpiRootComponent implements OnInit {

    private userInfoSubscription: Subscription;
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();

    constructor(
        private submissionHistoryService: SubmissionHistoryService,
        public readonly appComponent: AppComponent,
        public router: Router
    ) {}

    ngOnInit() {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {
            this.userInfo = message
        })
    }
}
